module.exports = __webpack_public_path__ + "static/media/design-down.84ab58fb.svg";